import React from 'react'
import { Box, Dialog, DialogContent, DialogActions } from '@mui/material'
import { Model, PartialAction, State, StateObj } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { ConfirmDialog } from 'src/features/brands/components/confirm/ConfirmDialog'
import { startConfirmMessageGenerator, useConfirm, useSelectBaseModel } from 'src/features/brands/hooks/baseModelSelecter'
import { ModelCard } from 'src/features/brands/components/BaseModelSelector/ModelCard'
import { useModelSelector } from 'src/features/brands/components/BaseModelSelector/hooks'
import { useRouter } from 'next/router'
import { positionFilterLogic } from './util'

const SET_BASE_MODEL = 'setBaseModel'

type Props = {
  state: State
  models: Model[]
  kinds?: StateObj
  path?: string
  dispatch: React.Dispatch<PartialAction>
  filterLogic?: (m?: Model) => boolean
}

export const BaseModelSelector: React.FC<Props> = ({ state, models, kinds = { label: '硬式', value: 'hard' }, path, dispatch, filterLogic }) => {
  const { isEn, t } = useLocale()
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(true)
  const { isConfirmOpen, setIsConfirmOpen, handleConfirmOpen, handleConfirmClose } = useConfirm()
  const { selectedModel, handleBaseModel } = useSelectBaseModel()
  const message = startConfirmMessageGenerator(selectedModel, isEn, t)
  const handleStartSimulation = () => {
    dispatch({ type: SET_BASE_MODEL, baseModel: selectedModel, kinds })
    setIsDialogOpen(false)
    setIsConfirmOpen(false)
  }
  const router = useRouter()
  const urls = path ? path.split('/') : router.asPath.split('/')
  const { position, isReset } = useModelSelector(state, urls)
  const modelFilter = filterLogic ? filterLogic : positionFilterLogic(position)
  return (
    <Box>
      <Dialog open={isDialogOpen || isReset} maxWidth={'lg'}>
        <DialogContent>
          <Box position={'sticky'} left={0}>
            {t.PLEASE_SELECT_MODEL}
          </Box>
          <Box display={'flex'}>
            {models.filter(modelFilter).map((model) => (
              <ModelCard {...{ selectedModel, model, handleBaseModel }} key={model.productNumber} isOnlyImage={model.brand === 'ragdelion'} />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <ConfirmDialog
            isConfirmOpen={isConfirmOpen}
            openButtonLabel={t.START_SIMULATION}
            dialogMessage={message}
            color={'primary'}
            variant={'contained'}
            handleOkButton={handleConfirmOpen}
            handleCancelButton={handleConfirmClose}
            handleExecuteButton={handleStartSimulation}
            disabled={!selectedModel}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}
